var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 144,
    viewBox: "0 0 221 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221 0.75V143.5H0.5L221 0.75Z",
    fill: "#67767E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottom);
export default __webpack_public_path__ + "static/media/bottom.361fdf08a028a1852519d80816a12419.svg";
export { ForwardRef as ReactComponent };